export default function AboutMe() {
  return (
    <section id="AboutMe" className="about--section">
      <div className="about--section--img">
        <img src="./img/bout-me.png" alt="About Me" />
      </div>
      <div className="hero--section--content--box about--section--box">
        <div className="hero--section--content">
          <p className="section--title">About Me</p>
         
          <p className="hero--section-description">
          I am Highly Proficient in Programming languages such as Java, C#, PHP, JavaScript, and Python, with additional expertise in framework and technologies such as
          ReactJS, SpringBoot, android studio, react native and DHIS2 configuration and development. Holds
          multiple professional certifications, including in AI Career Esentials, DHIS2, and DPro Project Management.
          </p>
          <p className="hero--section-description">Registered Teacher with the Teachers Council of Malawi and committed in creating engaging learning environments that
          promote hands-on understanding and academic growth. Adept at problem solving, with strong communication and teamwork abilities
          gained through both software development and teaching experience.
          </p>
        </div>
      </div>
    </section>
  );
}
